'use client'

import { useResolveLocaleField } from '@/app/[locale]/_hooks/useResolveLocaleField'
import { ICategory } from '@/app/[locale]/_types'
import { Avatar } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import { Link } from '@/i18n/navigation'
import { Stack, Text } from '@chakra-ui/react'
import Image from 'next/image'

export default function Mobile({
  category,
  isSeperatePage,
  showImage = false,
}: {
  isSeperatePage: boolean
  category: ICategory
  showImage: boolean
}) {
  const resolveLocale = useResolveLocaleField()
  const title = resolveLocale(category?.title)

  if (showImage) {
    return (
      <Stack mr={4} gap={2} minW='56px' asChild>
        <Link
          href={
            isSeperatePage
              ? `/category/${category?.slug}`
              : `#${category?.slug}`
          }
          scroll={!isSeperatePage}
        >
          {category?.image ? (
            <Image
              width='56'
              height='56'
              style={{
                borderRadius: '16px',
                width: '56px',
                height: '56px',
                objectFit: 'cover',
              }}
              src={process.env.BASE_URL + category?.image}
              alt={title}
            />
          ) : (
            <Avatar
              width='56px'
              height='56px'
              borderRadius='16px'
              name={title}
              bg='var(--bg-default)'
              color='text'
            />
          )}
          <Text
            whiteSpace='nowrap'
            textAlign='center'
            fontSize='xs'
            lineClamp='2'
          >
            {title}
          </Text>
        </Link>
      </Stack>
    )
  }

  return (
    <Link
      href={
        isSeperatePage ? `/category/${category?.slug}` : `#${category?.slug}`
      }
      scroll={!isSeperatePage}
    >
      <Button rounded={12} fontSize='sm' variant='ghost' fontWeight={500}>
        {title}
      </Button>
    </Link>
  )
}
